import React, { useRef, useState } from "react";
import ChatBox from "../../components/ChatBox/ChatBox";
import Conversation from "../../components/Coversation/Conversation";
import NavIcons from "../../components/NavIcons/NavIcons";
import "./Chat.css";
import "./custom.css";
import { useEffect } from "react";
import { userChats } from "../../api/ChatRequests";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";

import { getToken } from "../../lib/apiRequest";

const currentUser = getToken("user");

const Chat = () => {


  const dispatch = useDispatch();
  const socket = useRef();
  const user = currentUser;

  const [chats, setChats] = useState([]);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [sendMessage, setSendMessage] = useState(null);
  const [receivedMessage, setReceivedMessage] = useState(null);

  const query = window.location.search.substring(1);
  var vars = query.split("&");
  var pair = vars[0].split("=");

  // Get the chat in chat section
  useEffect(() => {
    const getChats = async () => {
      try {
        const { data } = await userChats(currentUser._id);
        setChats(data);

        if(pair[1] != null){
          for( let i=0; i < data.length; i++){   
           
              //console.log("Pair Chat ID ", pair[1])
              //console.log("MAIN Chat ID ", data[i]._id)

             if(pair[1] == data[i]._id){
               setCurrentChat(data[i]);
             }   
          }
     }

      } catch (error) {
        console.log(error);
      }
    };
    getChats();
  }, [currentUser._id]);

  // Connect to Socket.io
  useEffect(() => {
    socket.current = io("https://weerdysocket.herokuapp.com", { transports : ['websocket'] });
    socket.current.emit("new-user-add", currentUser._id);
    socket.current.on("get-users", (users) => {
      setOnlineUsers(users);
    });
  }, [currentUser]);

  // Send Message to socket server
  useEffect(() => {
    if (sendMessage!==null) {
      socket.current.emit("send-message", sendMessage);}
  }, [sendMessage]);


  // Get the message from socket server
  useEffect(() => {
    socket.current.on("recieve-message", (data) => {
      console.log(data)
      setReceivedMessage(data);
    }

    );
  }, []);

  const checkOnlineStatus = (chat) => {
    try {
    const chatMember = chat.members.find((member) => member !== user._id);
    const online = onlineUsers.find((user) => user.userId === chatMember);
    return online ? true : false;
  } catch (error) {
    console.log(error);
  }
  };


  
  useEffect(() => {
    const setChat = async () => {
        
      try {
        console.log("PAIR ", pair[1] )

      } catch (error) {
        console.log(error);
      }  


    };
    setChat();
    }, []);

  return (
    <div className="Chat">
      {/* Left Side */}
      <div className="Left-side-chat">
        <div className="Chat-container">
          <h5>Chats</h5>
          <div className="Chat-list">
            {chats.map((chat) => (
              <div class="follower conversation" id={chat._id} 
                onClick={() => {
                  setCurrentChat(chat);
                }}
              >
                <Conversation
                  data={chat}
                  currentUser={currentUser._id}
                  online={checkOnlineStatus(chat)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Side */}

      <div className="Right-side-chat">
        <div style={{ width: "20rem", alignSelf: "flex-end", display:"none" }}>
          <NavIcons />
        </div>
   
        <ChatBox
          chat={currentChat}
          currentUser={currentUser._id}
          setSendMessage={setSendMessage}
          receivedMessage={receivedMessage}
          online={checkOnlineStatus(currentChat)}
        />
      </div>
    </div>
  );
};

export default Chat;
